import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { AuthShell } from "./LoginPage";
import { TID } from "@/constants/testIds";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe mis à jour");
      navigate("/login");
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail));
    }
    setLoading(false);
  };

  return (
    <AuthShell>
      <h1 className="font-serif text-3xl sm:text-4xl">Nouveau mot de passe</h1>
      <p className="mt-2 text-muted-foreground">Choisissez un mot de passe robuste (8 caractères min.).</p>
      <form onSubmit={onSubmit} className="mt-8 space-y-4">
        <div>
          <Label htmlFor="pwd">Nouveau mot de passe</Label>
          <Input id="pwd" data-testid={TID.resetPassword} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} className="mt-1.5" />
        </div>
        {error && <div className="rounded-xl border border-destructive/30 bg-destructive/5 px-4 py-3 text-sm text-destructive">{error}</div>}
        <Button type="submit" disabled={loading || !token} className="btn-pill w-full" data-testid={TID.resetSubmit}>
          {loading ? "Enregistrement…" : "Réinitialiser"}
        </Button>
      </form>
      <p className="mt-6 text-sm text-muted-foreground text-center">
        <Link to="/login" className="text-accent link-underline">Retour à la connexion</Link>
      </p>
    </AuthShell>
  );
}
